import { render } from "./PhotoGrid.vue?vue&type=template&id=463cd8da&scoped=true"
import script from "./PhotoGrid.vue?vue&type=script&lang=js"
export * from "./PhotoGrid.vue?vue&type=script&lang=js"

import "./PhotoGrid.vue?vue&type=style&index=0&id=463cd8da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463cd8da"]])

export default __exports__